import useBreakpointIndex from './useBreakpointIndex.js';
import 'react';
import '@emotion/react';

function useResponsiveValue(values) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const array = Array.isArray(values) ? values : [values];
  const index = useBreakpointIndex(options);
  return array[index >= array.length ? array.length - 1 : index];
}

export { useResponsiveValue as default };
